export default "__VITE_ASSET__CCZJJrwn__"